<template>
    <div class="error-container">
      <h1>Ya es Año Nuevo bola de imbéciles.</h1>
      <video src="@/assets/VID-20241225-WA0001.mp4" alt="Furinavidad" class="error-image" controls />
    </div>
    <div>
      <AdSense />
    </div>
  </template>
  
  <script>
  import AdSense from './AdSense.vue';
  export default {
    components: {
      AdSense
    }
  };
  </script>
  
  <style>
  /* Agrega aquí los estilos específicos */
  </style>